import { Icon, type IconProps } from './Icon';

/** Buscar. Substitui o `⌕`, que era U+2315 TELEPHONE RECORDER. */
export function SearchIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m21 21-4.34-4.34" />
      <circle cx="11" cy="11" r="8" />
    </Icon>
  );
}
